var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 4.56689H3.18573L3.803 7.31653L5.13521 13.2495H14.7469L16.3343 7.87281",
    stroke: "#2F2F2F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94436 16.5C7.50644 16.5 7.96209 16.0444 7.96209 15.4823C7.96209 14.9202 7.50644 14.4646 6.94436 14.4646C6.38229 14.4646 5.92664 14.9202 5.92664 15.4823C5.92664 16.0444 6.38229 16.5 6.94436 16.5Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3427 16.5C13.9048 16.5 14.3604 16.0444 14.3604 15.4823C14.3604 14.9202 13.9048 14.4646 13.3427 14.4646C12.7806 14.4646 12.325 14.9202 12.325 15.4823C12.325 16.0444 12.7806 16.5 13.3427 16.5Z",
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.162 3V8.97255",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1483 5.98631H7.17542",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBasket);
export default __webpack_public_path__ + "static/media/add-basket.3d123d427c2d4f7e5b0a016fab788c9a.svg";
export { ForwardRef as ReactComponent };